import styled from 'styled-components';
import Button from '../../BuildingBlocks/Button';
import Grid from '../../Utility/Grid';
import Text from '../../BuildingBlocks/Text';
import { colors, fonts, media, mixins } from '../../css';

export const StyledDesktopSummaryWrapper = styled.div`
  ${props =>
    props.propertyPane
      ? `padding:  0 0 ${mixins.pxToRem(20)} 0;`
      : `padding:  0 ${mixins.pxToRem(20)} ${mixins.pxToRem(20)} ${mixins.pxToRem(20)}`};
  ${props => (props.propertyPane ? `` : `background-color: ${colors.colorGrey05};`)}
  ${props => (props.propertyPane ? `` : `width: 100%`)}
`;

export const StyledSummaryDesktopBackground = styled.div`
  ${props => (props.propertyPane ? `padding: 25px 0;` : `padding: 25px 20px`)}
  background-color: ${colors.colorWhite};
  ${props => (props.propertyPane ? `margin-bottom: 75px;` : ``)}
`;

export const StyledSummaryText = styled.p`
  font-family: ${fonts.fontRegular};
  font-size: ${mixins.pxToRem(14)};
  color: ${colors.colorGrey02};
  letter-spacing: ${mixins.pxToRem(-0.35)};
  text-align: center;
`;

export const StyledCapacityWrapper = styled.div`
  font-family: ${fonts.fontRegular};
  font-size: ${mixins.pxToRem(14)};
  color: ${colors.colorGrey02};
  letter-spacing: ${mixins.pxToRem(-0.11)};
  line-height: ${mixins.pxToRem(22)};
  text-align: center;
  padding-top: ${mixins.pxToRem(10)};
`;

export const StyledCapacityText = styled.p`
  display: inline-block;
`;

export const StyledNoteText = styled.p`
  font-family: ${fonts.fontRegular};
  font-size: ${mixins.pxToRem(10)};
  color: ${colors.colorGrey02};
  letter-spacing: ${mixins.pxToRem(-0.35)};
  text-align: right;
`;

export const StyledBoldText = styled.span`
  font-family: ${fonts.fontBold};
`;

export const StyledDoubleColumn = styled(Grid.Row)`
  position: relative;
  top: ${mixins.pxToRem(5)};
`;

export const StyledCostColumn = styled(Grid.Col)`
  position: relative;
  width: 50%;
  display: inline-block;
  padding-left: ${mixins.pxToRem(30)};
`;

export const StyledEstimatedLabelContainer = styled.div`
  width: 75%;
  display: inline-block;
  padding-left: ${mixins.pxToRem(18)};
  margin-top: -10px;
`;

export const StyledTotalPrice = styled.h4`
  float: left;
  font-family: ${fonts.fontBold};
  ${media.greaterThan('lg')`
    font-size: ${mixins.pxToRem(22)};
  `};

  ${media.greaterThan('xl')`
    font-size: ${mixins.pxToRem(18)};
  `};
`;

export const StyledCurrencyLine = styled(Text.CopyBody)`
  float: left;
  padding-left: ${mixins.pxToRem(5)};
  font-size: ${mixins.pxToRem(14)};
  margin-top: ${mixins.pxToRem(1)};
  position: relative;
  bottom: ${mixins.pxToRem(3)};
  padding-bottom: 0;
  && {
    margin-bottom: 0;
  }
`;

export const StyledBookNowColumn = styled(Grid.Col)`
  width: 50%;
  display: inline-block;
  position: ${props => (props.propertyPane ? `fixed` : `relative`)};
`;

export const StyledEstimatedLabel = styled(Text.CopyBody)`
  font-size: ${mixins.pxToRem(14)};
`;

export const StyledBookNowButton = styled.div`
  position: fixed;
  bottom: 0px;
  padding: 10px 15px;
  z-index: 20;
  background-color: ${colors.colorGrey05};

  @media (min-width: 1000px) {
    width: 22%;
  }

  @media (min-width: 1400px) {
    width: 22.5%;
  }

  @media (min-width: 1700px) {
    width: 22.75%;
  }

  @media (min-width: 1900px) {
    width: 23%;
  }

  @media (min-width: 2100px) {
    width: 23.25%;
  }
`;

// Mobile Styles

export const StyledSummaryWrapper = styled.div`
  padding: ${mixins.pxToRem(25)} ${mixins.pxToRem(32)} ${mixins.pxToRem(25)} ${mixins.pxToRem(32)};
  background-color: ${colors.colorWhite};
  border-top: 1px solid ${colors.colorGrey04};
  ${media.greaterThan('md')`
  padding: ${mixins.pxToRem(25)} ${mixins.pxToRem(38)} ${mixins.pxToRem(25)} ${mixins.pxToRem(38)};
  `};
`;

export const StyledBookingLabel = styled(Text.CopyBody)`
  position: relative;
  top: ${mixins.pxToRem(-8)};
  font-weight: bold;
  float: right;
`;

export const StyledMobileButton = styled(Button)`
  padding: ${mixins.pxToRem(8)} ${mixins.pxToRem(32)} ${mixins.pxToRem(5)} ${mixins.pxToRem(32)};
  ${media.greaterThan('md')`
    padding: ${mixins.pxToRem(8)} ${mixins.pxToRem(38)} ${mixins.pxToRem(5)} ${mixins.pxToRem(38)};
  `};
`;

export const StyledMiniCurrencyLine = styled(Text.CopyMini)`
  float: left;
  padding-left: ${mixins.pxToRem(5)};
  margin-top: ${mixins.pxToRem(10)};
  padding-bottom: 0;
  && {
    margin-bottom: 0;
  }
`;

export const StyledMobileTotalPrice = styled(Text.HeadingSecond)`
  font-size: 22px;
  float: left;
`;

export const AlbertaTaxNotification = styled.div`
  width: 100%;
  background-color: ${colors.alertYellow02};
  height: auto;
  padding: 10px;
  margin: 18px 0;
  display: flex;
`;

export const NotificationCircle = styled.div`
  width: 20px;
  height: 20px;
  min-width: 20px;
  min-height: 20px;
  border-radius: 50%;
  background-color: ${colors.colorOrange03};
  margin-right: 10px;
`;
